import { getPageNumbers } from "./userConstants";

const PgBtn = ({ children, disabled, active, onClick }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className={`min-w-[34px] h-[34px] px-2 rounded-[9px] border text-[12.5px] font-semibold transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${
      active
        ? "bg-[#0C1120] text-white border-[#0C1120]"
        : "bg-white text-[#2B3142] border-[#E0E3EB] hover:border-[#A8AEBC]"
    }`}
    style={{ fontFamily: "Poppins" }}
  >
    {children}
  </button>
);

const UsersPagination = ({ currentPage, totalPages, totalUsers, usersPerPage, onPageChange }) => {
  if (totalPages <= 1) return null;

  const pages = getPageNumbers(currentPage, totalPages);
  const startItem = (currentPage - 1) * usersPerPage + 1;
  const endItem = Math.min(currentPage * usersPerPage, totalUsers);

  return (
    <div className="mt-[18px] flex items-center justify-between gap-3 flex-wrap">
      <span className="text-[12.5px] text-[#8A90A2]">
        Showing {startItem}–{endItem} of {totalUsers.toLocaleString()}
      </span>
      <div className="flex gap-1.5">
        <PgBtn disabled={currentPage <= 1} onClick={() => onPageChange(1)}>«</PgBtn>
        <PgBtn disabled={currentPage <= 1} onClick={() => onPageChange(currentPage - 1)}>‹</PgBtn>
        {pages.map((p) => (
          <PgBtn key={p} active={p === currentPage} onClick={() => onPageChange(p)}>{p}</PgBtn>
        ))}
        <PgBtn disabled={currentPage >= totalPages} onClick={() => onPageChange(currentPage + 1)}>›</PgBtn>
        <PgBtn disabled={currentPage >= totalPages} onClick={() => onPageChange(totalPages)}>»</PgBtn>
      </div>
    </div>
  );
};

export default UsersPagination;
